/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import TravelCostErrorsInner from './TravelCostErrorsInner';
import TravelCostResponsesInner from './TravelCostResponsesInner';

/**
 * The CostMatrixResponse model module.
 * @module model/CostMatrixResponse
 * @version 0.0.2
 */
class CostMatrixResponse {
    /**
     * Constructs a new <code>CostMatrixResponse</code>.
     * The response schema for a cost matrix calculation request. This includes the travel costs and any errors encountered during the calculation.
     * @alias module:model/CostMatrixResponse
     */
    constructor() { 
        
        CostMatrixResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CostMatrixResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CostMatrixResponse} obj Optional instance to populate.
     * @return {module:model/CostMatrixResponse} The populated <code>CostMatrixResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CostMatrixResponse();

            if (data.hasOwnProperty('travelCostResponses')) {
                obj['travelCostResponses'] = ApiClient.convertToType(data['travelCostResponses'], [TravelCostResponsesInner]);
            }
            if (data.hasOwnProperty('travelCostErrors')) {
                obj['travelCostErrors'] = ApiClient.convertToType(data['travelCostErrors'], [TravelCostErrorsInner]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CostMatrixResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CostMatrixResponse</code>.
     */
    static validateJSON(data) {
        if (data['travelCostResponses']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['travelCostResponses'])) {
                throw new Error("Expected the field `travelCostResponses` to be an array in the JSON data but got " + data['travelCostResponses']);
            }
            // validate the optional field `travelCostResponses` (array)
            for (const item of data['travelCostResponses']) {
                TravelCostResponsesInner.validateJSON(item);
            };
        }
        if (data['travelCostErrors']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['travelCostErrors'])) {
                throw new Error("Expected the field `travelCostErrors` to be an array in the JSON data but got " + data['travelCostErrors']);
            }
            // validate the optional field `travelCostErrors` (array)
            for (const item of data['travelCostErrors']) {
                TravelCostErrorsInner.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * This schema defines the response for travel costs between pairs of locations.
 * @member {Array.<module:model/TravelCostResponsesInner>} travelCostResponses
 */
CostMatrixResponse.prototype['travelCostResponses'] = undefined;

/**
 * This schema defines an error encountered during the cost matrix calculation. Each error represents a problem with calculating the travel cost between two locations.
 * @member {Array.<module:model/TravelCostErrorsInner>} travelCostErrors
 */
CostMatrixResponse.prototype['travelCostErrors'] = undefined;






export default CostMatrixResponse;

